export default [
    //////////////////////////////////////////////////////////////////////////////////////
    //KAART
    //////////////////////////////////////////////////////////////////////////////////////
    //KAART GLTF
    {
        name: 'kaartGltf',
        type: 'gltfModel',
        path: 'models/pegasus_026.glb'
    },
    //KAART TEXTURE
    {
        name: 'kaartOverzicht',
        type: 'texture',
        path: 'textures/Kaart.jpg'
    },
    //KAART ROUGHNESS TEXTURE
    {
        name: 'kaartRoughness',
        type: 'texture',
        path: 'textures/Kaart_roughness.jpg'
    },

    //////////////////////////////////////////////////////////////////////////////////////
    //ROUTE
    //////////////////////////////////////////////////////////////////////////////////////
    //ROUTE GLTF
    {
        name: 'routeGltf',
        type: 'gltfModel',
        path: 'models/pegasus_route_02.glb'
    },
    //STAD SELECTIE TEXTURE
    {
        name: 'selectieTexture',
        type: 'texture',
        path: 'textures/stad_selectie.png'
    },
    //ROUTE TEXTURE
    {
        name: 'routeTexture',
        type: 'texture',
        path: 'textures/route_lijn.png'
    },

    //////////////////////////////////////////////////////////////////////////////////////
    //POIs
    //////////////////////////////////////////////////////////////////////////////////////
    //models world
    {
        name: 'models_world_gltf',
        type: 'gltfModel',
        path: 'models/POI_combined_8.glb'
    },

    //////////////////////////////////////////////////////////////////////////////////////
    //UI
    //////////////////////////////////////////////////////////////////////////////////////
    //POI UI GLTF
    {
        name: 'ui_element_Gltf',
        type: 'gltfModel',
        path: 'models/ui_element_2.glb'
    },
    //POI UI TEXTURE
    {
        name: 'ui_element',
        type: 'texture',
        path: 'textures/ui_element.png'
    },
    //POI ICONS IMAGE
    {
        name: 'ui_icons_image',
        type: 'texture',
        path: 'textures/ui_icons_image.png'
    },
    //POI ICONS RED
    {
        name: 'ui_icons_red',
        type: 'texture',
        path: 'textures/ui_icons_red.png'
    },
    //POI ICONS GRAY
    {
        name: 'ui_icons_gray',
        type: 'texture',
        path: 'textures/ui_icons_gray.png'
    },

    //////////////////////////////////////////////////////////////////////////////////////
    //LOSSE OBJECTEN
    //////////////////////////////////////////////////////////////////////////////////////
    //AIRPLANE B24 GLTF
    {
        name: 'airplane_b24_gltf',
        type: 'gltfModel',
        path: 'models/airplane_animation_b24_02.glb'
    },
    //AIRPLANE SPITFIRE GLTF
    {
        name: 'airplane_spitfire_gltf',
        type: 'gltfModel',
        path: 'models/airplane_animation_spitfire_02.glb'
    },
    //BOM GLTF
    {
        name: 'bom_animatie_gltf',
        type: 'gltfModel',
        path: 'models/bom_animatie.glb'
    },

    //////////////////////////////////////////////////////////////////////////////////////
    //LOSSE TEXTURES
    //////////////////////////////////////////////////////////////////////////////////////
    //TREE TEXTURE
    {
        name: 'treeTexture',
        type: 'texture',
        path: 'textures/tree.png'
    },
    //CLOUD TEXTURE
    {
        name: 'cloudTexture',
        type: 'texture',
        path: 'textures/cloud.png'
    },
    //FLARE TEXTURE
    {
        name: 'flareTexture',
        type: 'texture',
        path: 'textures/flare.png'
    },
    {
        name: 'displacementTexture',
        type: 'texture',
        path: 'textures/displacement.jpg'
    },

    //////////////////////////////////////////////////////////////////////////////////////
    //AUDIO
    //////////////////////////////////////////////////////////////////////////////////////
    //AMBIENT
    {
        name: 'ambient_sound',
        type: 'audio',
        path: 'audio/PG_ambient.mp3'
    },
    //AMBIENT WIND
    {
        name: 'ambient_wind_sound',
        type: 'audio',
        path: 'audio/PG_ambient_wind.mp3'
    },
    //CLICK
    {
        name: 'poi_click_sound',
        type: 'audio',
        path: 'audio/PG_POI_click_1.mp3'
    },
    //ZOOM-OUT
    {
        name: 'poi_zoom_out_sound',
        type: 'audio',
        path: 'audio/PG_woosh_camera_2.mp3'
    },
    //HOVER
    {
        name: 'poi_hover_sound',
        type: 'audio',
        path: 'audio/PG_POI_click_2.mp3'
    },
    //FLARE SHOT
    {
        name: 'flare_shot_sound',
        type: 'audio',
        path: 'audio/PG_flare2.mp3'
    },
    //PLANES
    {
        name: 'spitfire_sound',
        type: 'audio',
        path: 'audio/PG_plane_spitfire.mp3'
    },
    {
        name: 'b24_sound',
        type: 'audio',
        path: 'audio/PG_plane_b24.mp3'
    },
    //FLARE SHOT
    {
        name: 'explosion_sound',
        type: 'audio',
        path: 'audio/PG_explosion.mp3'
    },
    //POI SOUND
    {
        name: 'poi_1_sound',
        type: 'audio',
        path: 'audio/PG_atmos_film_1.mp3'
    },
    {
        name: 'poi_2_sound',
        type: 'audio',
        path: 'audio/PG_atmos_film_2.mp3'
    },
    {
        name: 'poi_3_sound',
        type: 'audio',
        path: 'audio/PG_atmos_film_3.mp3'
    },
    {
        name: 'poi_4_sound',
        type: 'audio',
        path: 'audio/PG_atmos_film_4.mp3'
    },
    {
        name: 'poi_5_sound',
        type: 'audio',
        path: 'audio/PG_atmos_film_5.mp3'
    },
    {
        name: 'poi_6_sound',
        type: 'audio',
        path: 'audio/PG_atmos_film_6.mp3'
    },
    {
        name: 'poi_7_sound',
        type: 'audio',
        path: 'audio/PG_atmos_film_7.mp3'
    },
    {
        name: 'poi_8_sound',
        type: 'audio',
        path: 'audio/PG_atmos_film_8.mp3'
    },


















    //////////////////////////////////////////////////////////////////////////////////////
    //KAART TEXTURES
    //////////////////////////////////////////////////////////////////////////////////////
    {
        name: 'LOD_close_0',
        type: 'texture',
        path: 'textures/Tiles/Kaart-1-1.jpg'
    },
    {
        name: 'LOD_close_1',
        type: 'texture',
        path: 'textures/Tiles/Kaart-1-2.jpg'
    },
    {
        name: 'LOD_close_2',
        type: 'texture',
        path: 'textures/Tiles/Kaart-1-3.jpg'
    },
    {
        name: 'LOD_close_3',
        type: 'texture',
        path: 'textures/Tiles/Kaart-1-4.jpg'
    },
    {
        name: 'LOD_close_4',
        type: 'texture',
        path: 'textures/Tiles/Kaart-1-5.jpg'
    },
    {
        name: 'LOD_close_5',
        type: 'texture',
        path: 'textures/Tiles/Kaart-1-6.jpg'
    },
    {
        name: 'LOD_close_6',
        type: 'texture',
        path: 'textures/Tiles/Kaart-1-7.jpg'
    },
    /////////////////////////////////////////////////////////////
    {
        name: 'LOD_close_7',
        type: 'texture',
        path: 'textures/Tiles/Kaart-2-1.jpg'
    },
    {
        name: 'LOD_close_8',
        type: 'texture',
        path: 'textures/Tiles/Kaart-2-2.jpg'
    },
    {
        name: 'LOD_close_9',
        type: 'texture',
        path: 'textures/Tiles/Kaart-2-3.jpg'
    },
    {
        name: 'LOD_close_10',
        type: 'texture',
        path: 'textures/Tiles/Kaart-2-4.jpg'
    },
    {
        name: 'LOD_close_11',
        type: 'texture',
        path: 'textures/Tiles/Kaart-2-5.jpg'
    },
    {
        name: 'LOD_close_12',
        type: 'texture',
        path: 'textures/Tiles/Kaart-2-6.jpg'
    },
    {
        name: 'LOD_close_13',
        type: 'texture',
        path: 'textures/Tiles/Kaart-2-7.jpg'
    },
    /////////////////////////////////////////////////////////////
    {
        name: 'LOD_close_14',
        type: 'texture',
        path: 'textures/Tiles/Kaart-3-1.jpg'
    },
    {
        name: 'LOD_close_15',
        type: 'texture',
        path: 'textures/Tiles/Kaart-3-2.jpg'
    },
    {
        name: 'LOD_close_16',
        type: 'texture',
        path: 'textures/Tiles/Kaart-3-3.jpg'
    },
    {
        name: 'LOD_close_17',
        type: 'texture',
        path: 'textures/Tiles/Kaart-3-4.jpg'
    },
    {
        name: 'LOD_close_18',
        type: 'texture',
        path: 'textures/Tiles/Kaart-3-5.jpg'
    },
    {
        name: 'LOD_close_19',
        type: 'texture',
        path: 'textures/Tiles/Kaart-3-6.jpg'
    },
    {
        name: 'LOD_close_20',
        type: 'texture',
        path: 'textures/Tiles/Kaart-3-7.jpg'
    },
    /////////////////////////////////////////////////////////////
    {
        name: 'LOD_close_21',
        type: 'texture',
        path: 'textures/Tiles/Kaart-4-1.jpg'
    },
    {
        name: 'LOD_close_22',
        type: 'texture',
        path: 'textures/Tiles/Kaart-4-2.jpg'
    },
    {
        name: 'LOD_close_23',
        type: 'texture',
        path: 'textures/Tiles/Kaart-4-3.jpg'
    },
    {
        name: 'LOD_close_24',
        type: 'texture',
        path: 'textures/Tiles/Kaart-4-4.jpg'
    },
    {
        name: 'LOD_close_25',
        type: 'texture',
        path: 'textures/Tiles/Kaart-4-5.jpg'
    },
    {
        name: 'LOD_close_26',
        type: 'texture',
        path: 'textures/Tiles/Kaart-4-6.jpg'
    },
    {
        name: 'LOD_close_27',
        type: 'texture',
        path: 'textures/Tiles/Kaart-4-7.jpg'
    },
    /////////////////////////////////////////////////////////////
    {
        name: 'LOD_close_28',
        type: 'texture',
        path: 'textures/Tiles/Kaart-5-1.jpg'
    },
    {
        name: 'LOD_close_29',
        type: 'texture',
        path: 'textures/Tiles/Kaart-5-2.jpg'
    },
    {
        name: 'LOD_close_30',
        type: 'texture',
        path: 'textures/Tiles/Kaart-5-3.jpg'
    },
    {
        name: 'LOD_close_31',
        type: 'texture',
        path: 'textures/Tiles/Kaart-5-4.jpg'
    },
    {
        name: 'LOD_close_32',
        type: 'texture',
        path: 'textures/Tiles/Kaart-5-5.jpg'
    },
    {
        name: 'LOD_close_33',
        type: 'texture',
        path: 'textures/Tiles/Kaart-5-6.jpg'
    },
    {
        name: 'LOD_close_34',
        type: 'texture',
        path: 'textures/Tiles/Kaart-5-7.jpg'
    },
    /////////////////////////////////////////////////////////////
    {
        name: 'LOD_close_35',
        type: 'texture',
        path: 'textures/Tiles/Kaart-6-1.jpg'
    },
    {
        name: 'LOD_close_36',
        type: 'texture',
        path: 'textures/Tiles/Kaart-6-2.jpg'
    },
    {
        name: 'LOD_close_37',
        type: 'texture',
        path: 'textures/Tiles/Kaart-6-3.jpg'
    },
    {
        name: 'LOD_close_38',
        type: 'texture',
        path: 'textures/Tiles/Kaart-6-4.jpg'
    },
    {
        name: 'LOD_close_39',
        type: 'texture',
        path: 'textures/Tiles/Kaart-6-5.jpg'
    },
    {
        name: 'LOD_close_40',
        type: 'texture',
        path: 'textures/Tiles/Kaart-6-6.jpg'
    },
    {
        name: 'LOD_close_41',
        type: 'texture',
        path: 'textures/Tiles/Kaart-6-7.jpg'
    },
    /////////////////////////////////////////////////////////////
    {
        name: 'LOD_close_42',
        type: 'texture',
        path: 'textures/Tiles/Kaart-7-1.jpg'
    },
    {
        name: 'LOD_close_43',
        type: 'texture',
        path: 'textures/Tiles/Kaart-7-2.jpg'
    },
    {
        name: 'LOD_close_44',
        type: 'texture',
        path: 'textures/Tiles/Kaart-7-3.jpg'
    },
    {
        name: 'LOD_close_45',
        type: 'texture',
        path: 'textures/Tiles/Kaart-7-4.jpg'
    },
    {
        name: 'LOD_close_46',
        type: 'texture',
        path: 'textures/Tiles/Kaart-7-5.jpg'
    },
    {
        name: 'LOD_close_47',
        type: 'texture',
        path: 'textures/Tiles/Kaart-7-6.jpg'
    },
    {
        name: 'LOD_close_48',
        type: 'texture',
        path: 'textures/Tiles/Kaart-7-7.jpg'
    },
    //////////////////////////////////////////////////////////////////////////////////////
    //KAART TEXTURES
    //////////////////////////////////////////////////////////////////////////////////////
    {
        name: 'rough_close_0',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-1-1.png'
    },
    {
        name: 'rough_close_1',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-1-2.png'
    },
    {
        name: 'rough_close_2',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-1-3.png'
    },
    {
        name: 'rough_close_3',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-1-4.png'
    },
    {
        name: 'rough_close_4',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-1-5.png'
    },
    {
        name: 'rough_close_5',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-1-6.png'
    },
    {
        name: 'rough_close_6',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-1-7.png'
    },
    /////////////////////////////////////////////////////////////
    {
        name: 'rough_close_7',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-2-1.png'
    },
    {
        name: 'rough_close_8',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-2-2.png'
    },
    {
        name: 'rough_close_9',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-2-3.png'
    },
    {
        name: 'rough_close_10',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-2-4.png'
    },
    {
        name: 'rough_close_11',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-2-5.png'
    },
    {
        name: 'rough_close_12',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-2-6.png'
    },
    {
        name: 'rough_close_13',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-2-7.png'
    },
    /////////////////////////////////////////////////////////////
    {
        name: 'rough_close_14',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-3-1.png'
    },
    {
        name: 'rough_close_15',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-3-2.png'
    },
    {
        name: 'rough_close_16',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-3-3.png'
    },
    {
        name: 'rough_close_17',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-3-4.png'
    },
    {
        name: 'rough_close_18',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-3-5.png'
    },
    {
        name: 'rough_close_19',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-3-6.png'
    },
    {
        name: 'rough_close_20',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-3-7.png'
    },
    /////////////////////////////////////////////////////////////
    {
        name: 'rough_close_21',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-4-1.png'
    },
    {
        name: 'rough_close_22',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-4-2.png'
    },
    {
        name: 'rough_close_23',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-4-3.png'
    },
    {
        name: 'rough_close_24',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-4-4.png'
    },
    {
        name: 'rough_close_25',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-4-5.png'
    },
    {
        name: 'rough_close_26',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-4-6.png'
    },
    {
        name: 'rough_close_27',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-4-7.png'
    },
    /////////////////////////////////////////////////////////////
    {
        name: 'rough_close_28',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-5-1.png'
    },
    {
        name: 'rough_close_29',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-5-2.png'
    },
    {
        name: 'rough_close_30',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-5-3.png'
    },
    {
        name: 'rough_close_31',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-5-4.png'
    },
    {
        name: 'rough_close_32',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-5-5.png'
    },
    {
        name: 'rough_close_33',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-5-6.png'
    },
    {
        name: 'rough_close_34',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-5-7.png'
    },
    /////////////////////////////////////////////////////////////
    {
        name: 'rough_close_35',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-6-1.png'
    },
    {
        name: 'rough_close_36',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-6-2.png'
    },
    {
        name: 'rough_close_37',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-6-3.png'
    },
    {
        name: 'rough_close_38',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-6-4.png'
    },
    {
        name: 'rough_close_39',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-6-5.png'
    },
    {
        name: 'rough_close_40',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-6-6.png'
    },
    {
        name: 'rough_close_41',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-6-7.png'
    },
    /////////////////////////////////////////////////////////////
    {
        name: 'rough_close_42',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-7-1.png'
    },
    {
        name: 'rough_close_43',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-7-2.png'
    },
    {
        name: 'rough_close_44',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-7-3.png'
    },
    {
        name: 'rough_close_45',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-7-4.png'
    },
    {
        name: 'rough_close_46',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-7-5.png'
    },
    {
        name: 'rough_close_47',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-7-6.png'
    },
    {
        name: 'rough_close_48',
        type: 'texture',
        path: 'textures/Tiles_roughness/roughness-7-7.png'
    },
]